// @ts-nocheck
import Button from "@store/MobiusOverrides/Button/Button";
import useExistingRef from "@toolkit/Framework/Common/Hooks/useExistingRef";
import isElementVisible from "@toolkit/Framework/Common/Utilities/isElementVisible";
import { useWindowContext } from "@toolkit/Framework/Components/WindowContext";
import React, { ComponentProps, forwardRef, useEffect, useState } from "react";

export interface InlineFormButtonProps extends ComponentProps<typeof Button> {
    updateProps?: Array<any>;
}

const getOffset = (element: HTMLElement, ignoreMargin?: boolean) => {
    let offset = element.getBoundingClientRect().top;

    if (ignoreMargin) {
        offset = offset - parseFloat(getComputedStyle(element).getPropertyValue("margin-top"));
    }

    return Math.ceil(offset);
};

const InlineFormButton = forwardRef<HTMLButtonElement, InlineFormButtonProps>(
    ({ updateProps = [], ...buttonProps }, ref) => {
        const { clientWidth } = useWindowContext();
        const buttonRef = useExistingRef(ref);
        const [isVisible, setIsVisible] = useState(true);

        setTimeout(() => {
            if (isVisible !== isElementVisible(buttonRef.current)) {
                setIsVisible(!isVisible);
            }
        });

        useEffect(() => {
            if (isVisible) {
                const button = buttonRef.current;

                if (button) {
                    const items = Array.from(button.parentNode?.childNodes || [])
                        .filter(x => x !== button)
                        .reverse() as HTMLElement[];

                    if (items.length) {
                        const buttonOffset = getOffset(button, true);
                        const shouldOffset = items.some(x => {
                            let shouldOffset = getOffset(x) === buttonOffset;

                            if (shouldOffset) {
                                const field = x.querySelector('[class*="FormInputWrapper-"]') as HTMLElement | null;

                                if (field) {
                                    button.style.marginTop = `${getOffset(field) - buttonOffset}px`;
                                } else {
                                    shouldOffset = false;
                                }
                            }

                            return shouldOffset;
                        });

                        if (!shouldOffset) {
                            button.style.marginTop = "";
                        }
                    }
                }
            }
        }, [clientWidth, isVisible, ...updateProps]);

        return <Button ref={buttonRef} {...buttonProps} />;
    },
);

export default InlineFormButton;
